import React from 'react';
import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';

const PrivacyPage = () => (
  <div className="min-h-screen bg-slate-50 py-16 px-4">
    <div className="max-w-2xl mx-auto">
      <div className="flex items-center gap-3 mb-8">
        <Shield className="w-7 h-7 text-blue-600" />
        <h1 className="text-2xl font-bold text-slate-900">Politique de confidentialité</h1>
      </div>
      <div className="bg-white rounded-xl border border-slate-200 p-8 space-y-8 text-sm text-slate-600 leading-relaxed">

        <section>
          <h2 className="text-base font-semibold text-slate-900 mb-2">Responsable du traitement</h2>
          <p>Mehdi Bouzera, entrepreneur individuel</p>
          <p>Nom commercial : LoyalPass</p>
          <p>12 rue des Renardières, 44100 Nantes</p>
          <p>SIRET : 931 555 304 00027</p>
          <p>Contact : <a href="mailto:contact@getloyalpass.fr" className="text-blue-600 underline">contact@getloyalpass.fr</a></p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-slate-900 mb-2">Données collectées</h2>
          <p className="font-medium text-slate-700 mt-3">Marchands</p>
          <ul className="list-disc ml-5 space-y-1 mt-1">
            <li>Nom, adresse email, nom de l'entreprise</li>
            <li>Données de facturation via Stripe (numéro de carte non stocké par LoyalPass)</li>
          </ul>
          <p className="font-medium text-slate-700 mt-3">Clients</p>
          <ul className="list-disc ml-5 space-y-1 mt-1">
            <li>Prénom, adresse email</li>
            <li>Code membre unique, historique de scans et de récompenses</li>
          </ul>
        </section>

        <section>
          <h2 className="text-base font-semibold text-slate-900 mb-2">Finalités du traitement</h2>
          <ul className="list-disc ml-5 space-y-1">
            <li>Gestion du programme de fidélité (tampons, points, récompenses)</li>
            <li>Envoi d'emails transactionnels (bienvenue, récompense obtenue, rappels)</li>
            <li>Statistiques agrégées pour le marchand (nombre de clients, scans, récompenses)</li>
          </ul>
        </section>

        <section>
          <h2 className="text-base font-semibold text-slate-900 mb-2">Durée de conservation</h2>
          <ul className="list-disc ml-5 space-y-1">
            <li>Comptes actifs : tant que le compte existe</li>
            <li>Comptes supprimés : 30 jours puis purge définitive</li>
            <li>Logs de sécurité : 1 an</li>
          </ul>
        </section>

        <section>
          <h2 className="text-base font-semibold text-slate-900 mb-2">Destinataires des données</h2>
          <ul className="list-disc ml-5 space-y-1">
            <li><strong>Stripe</strong> — traitement des paiements</li>
            <li><strong>Resend</strong> — envoi d'emails</li>
            <li><strong>Apple / Google</strong> — génération des passes Wallet</li>
          </ul>
        </section>

        <section>
          <h2 className="text-base font-semibold text-slate-900 mb-2">Hébergement</h2>
          <p>L'application est hébergée sur Railway (États-Unis). Les transferts de données hors UE sont encadrés par les Clauses Contractuelles Types (SCC) conformément au RGPD.</p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-slate-900 mb-2">Vos droits</h2>
          <p>Conformément au RGPD, vous disposez des droits suivants :</p>
          <ul className="list-disc ml-5 space-y-1 mt-1">
            <li><strong>Accès</strong> — obtenir une copie de vos données</li>
            <li><strong>Rectification</strong> — corriger des informations inexactes</li>
            <li><strong>Suppression</strong> — demander l'effacement de vos données</li>
            <li><strong>Opposition</strong> — vous opposer au traitement</li>
            <li><strong>Portabilité</strong> — recevoir vos données dans un format structuré</li>
          </ul>
          <p className="mt-2">Pour exercer vos droits : <a href="mailto:contact@getloyalpass.fr" className="text-blue-600 underline">contact@getloyalpass.fr</a></p>
        </section>

        <p className="text-xs text-slate-400 pt-4 border-t border-slate-100">Dernière mise à jour : 2 juillet 2026</p>
      </div>

      <div className="text-center mt-6">
        <Link to="/" className="text-sm text-slate-500 hover:text-blue-600 underline">Retour à l'accueil</Link>
      </div>
    </div>
  </div>
);

export default PrivacyPage;
